import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import PipelineView from './pages/pipeline-view';
import Dashboard from './pages/dashboard';
import ProjectsTimelineView from './pages/projects-timeline-view';
import DealEditModal from './pages/deal-edit-modal';
import ContactsManagement from './pages/contacts-management';
import CalendarView from './pages/calendar-view';
import DealAnalyticsDashboard from './pages/deal-analytics-dashboard';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<Dashboard />} />
        <Route path="/pipeline-view" element={<PipelineView />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/projects-timeline-view" element={<ProjectsTimelineView />} />
        <Route path="/deal-edit-modal" element={<DealEditModal />} />
        <Route path="/contacts-management" element={<ContactsManagement />} />
        <Route path="/calendar-view" element={<CalendarView />} />
        <Route path="/deal-analytics-dashboard" element={<DealAnalyticsDashboard />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
